import { RouteObject } from "react-router";

export const ErrorRoutes: RouteObject = {
    path: "*",
    lazy: async () => {
        const { NotFound } = await import("@/components/Application/NotFound");
        return { Component: NotFound };
    }
};